<div class="flex justify-between items-center">
    @if (showContentTabs || (!isKngPage && !hideAddButton)) {
        <nav
            mat-tab-nav-bar
            [tabPanel]="tabPanel"
            [disablePagination]="true"
            class="valben-tabs select-none">
            @if (showContentTabs) {
                <a
                    mat-tab-link
                    [active]="contentType === 0"
                    (click)="setContentType('Search')"
                >
                    Tablica
                </a>
            }
            @if (!isKngPage && !hideAddButton) {
                <a
                    mat-tab-link
                    [active]="contentType === 1"
                    (click)="setContentType('Add')"
                >
                    Dodaj
                </a>
            }
            @if (showContentTabs && !isApprovedPage) {
                <a
                    mat-tab-link
                    [active]="contentType === 2"
                    [disabled]="!editEnabled"
                    (click)="setContentType('Edit')"
                >
                    Uredi
                </a>
            }
        </nav>
    }
    <div class="grid grid-flow-col gap-5 pr-4">
        @if (isKngPage && !isApprovedPage && showKngNavigationButtons) {
            <button
                type="button"
                mat-flat-button
                class="valben-kng-button"
                (click)="goToSubmitted()"
            >
                Slanje prijava nadređenom
                @if ((kngSuperiorSubmitBadgeCount ?? 0) > 0) {
                    <span
                        class="inline-flex min-w-[1.25rem] shrink-0 items-center justify-center rounded-full bg-white px-1.5 py-0.5 text-xs font-semibold text-valamarblueprimary">
                        {{ kngSuperiorSubmitBadgeCount }}
                    </span>
                }
            </button>
        }
        @if (isKngPage && !isApprovedPage && showKngNavigationButtons) {
            <button
                type="button"
                mat-flat-button
                class="valben-kng-button"
                (click)="goToCommission()"
            >
                Pregled finalnih prijava
                @if ((kngCommissionReviewBadgeCount ?? 0) > 0) {
                    <span
                        class="inline-flex min-w-[1.25rem] shrink-0 items-center justify-center rounded-full bg-white px-1.5 py-0.5 text-xs font-semibold text-valamarblueprimary">
                        {{ kngCommissionReviewBadgeCount }}
                    </span>
                }
            </button>
        }
        @if (isApprovedPage) {
            <button
                type="button"
                mat-flat-button
                class="valben-kng-button"
                (click)="goToContractGeneration()"
            >
                Spremni za generiranje ugovora
                @if ((kngContractGenerationBadgeCount ?? 0) > 0) {
                    <span
                        class="inline-flex min-w-[1.25rem] shrink-0 items-center justify-center rounded-full bg-white px-1.5 py-0.5 text-xs font-semibold text-valamarblueprimary">
                        {{ kngContractGenerationBadgeCount }}
                    </span>
                }
            </button>
        }
        @if (showUploadSignedContractsButton) {
            <button
                type="button"
                mat-flat-button
                class="valben-kng-button"
                (click)="goToUploadSignedContracts()"
            >
                Upload potpisanih ugovora
                @if ((kngUploadSignedContractsBadgeCount ?? 0) > 0) {
                    <span
                        class="inline-flex min-w-[1.25rem] shrink-0 items-center justify-center rounded-full bg-white px-1.5 py-0.5 text-xs font-semibold text-valamarblueprimary">
                        {{ kngUploadSignedContractsBadgeCount }}
                    </span>
                }
            </button>
        }
    </div>
</div>

<!-- The tabs drive a router-outlet / ngSwitch that lives in the page, not here. mat-tab-nav-bar
     still requires a panel to point [tabPanel] at for the aria wiring, so this stays empty. -->
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
